import { BaseService } from "./base.service";
import { ErrorWrapper, ResponseWrapper } from "./util";

export class TermsOfUseService extends BaseService {
  static get entity() {
    return "termsOfUse";
  }

  static async getStatus(courseId, applicationId) {
    try {
      const response = await this.request({ auth: true }).get(
        `${process.env.VUE_APP_EAD_API_URL}/terms-of-use/status`,
        {
          params: { courseId },
          headers: { "X-ApplicationId": applicationId },
        }
      );
      return new ResponseWrapper({ status: 200, data: { success: true } }, response.data);
    } catch (error) {
      const message =
        error.response?.data && typeof error.response.data === "object" ? error.response.data.error : error.message;
      throw new ErrorWrapper(error, message);
    }
  }

  static async acceptTerms(termId, accepted, courseId, applicationUserId, applicationId) {
    try {
      const response = await this.request({ auth: true }).post(
        `${process.env.VUE_APP_EAD_API_URL}/terms-of-use/acceptance`,
        {
          termId,
          accepted,
          courseId,
          applicationUserId,
        },
        {
          headers: {
            "X-ApplicationId": applicationId,
          },
        }
      );

      return new ResponseWrapper({ status: 200, data: { success: true } }, response.data);
    } catch (error) {
      const message =
        error.response?.data && typeof error.response.data === "object" ? error.response.data.error : error.message;
      throw new ErrorWrapper(error, message);
    }
  }
}
